import {createStore, StoreProvider} from '@eitje/store'
import reducers from './reducers'
import * as Sentry from '@sentry/react'
import * as ReactotronModule from 'reactotron-react-js'

const Reactotron = ReactotronModule.default?.default || ReactotronModule

const setupReactotron = name => Reactotron.configure({name})

const {store, persistor} = createStore({
	key: 'eitje-admin',
	reducers,
	setupReactotron,
	sentryRedux: {sdk: Sentry},
})

export {store, persistor, StoreProvider}
